import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { LogoMark } from "./Logo";

export const PaidStep = ({ order }) => {
  const [count, setCount] = useState(5);
  const url = order?.whatsapp_url;

  useEffect(() => {
    localStorage.removeItem("maos_order");
    if (order?.id) localStorage.setItem("maos_last_order", order.id);
    if (!url) return undefined;
    if (count <= 0) { window.location.href = url; return undefined; }
    const t = setTimeout(() => setCount((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [count, url]);

  return (
    <div data-testid="paid-step" className="flex flex-col items-center py-4 text-center">
      <motion.div initial={{ scale: 0.4, rotate: -90, opacity: 0 }} animate={{ scale: 1, rotate: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 160, damping: 14 }}
        className="flex h-24 w-24 items-center justify-center rounded-full border border-[var(--gold)] text-[var(--gold)] shadow-[0_0_60px_rgba(203,163,101,0.4)]">
        <LogoMark className="h-12 w-12" />
      </motion.div>
      <h3 data-testid="paid-title" className="font-display mt-8 text-4xl">Pagamento confirmado</h3>
      <p className="mt-3 max-w-sm text-sm text-white/75">
        As cartas já estão sendo preparadas. Você será levado ao WhatsApp em <span className="text-[var(--gold)]">{count}s</span>.
      </p>
      <p data-testid="paid-sla-note" className="mt-3 max-w-sm text-xs text-white/60">
        O atendimento pode ocorrer em até 24 horas, dependendo da quantidade de atendimentos realizados.
      </p>
      <a href={url} data-testid="paid-whatsapp-btn"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-[var(--gold)] px-8 py-4 text-sm font-semibold uppercase tracking-[0.18em] text-[#080312] transition-colors duration-300 hover:bg-[var(--gold-hi)]">
        <MessageCircle className="h-4 w-4" /> Ir para o WhatsApp
      </a>
      <a href={`/pedido/${order?.id}`} data-testid="paid-track-link" className="mt-4 text-sm text-white/75 underline decoration-[#CBA365]/50 underline-offset-8 hover:text-[#CBA365]">
        Acompanhar meu pedido
      </a>
    </div>
  );
};
